import Api from '@/modules/core/api/api.ts';
import { GanttEndPoint } from '@/modules/common/enums/end-point.ts';
import GanttItem from '@/modules/viewer/models/gantt/gantt-item.ts';
import { GanttLinkOptionCreator } from '@/modules/viewer/models/option/gantt-link-option.ts';
import { GanttItemAdapter } from '@/modules/viewer/adapters/gantt-item.adapter.ts';
import type { GanttRoutePointAvailableActionsDto } from '@/modules/shared/dto/gantt-route-point-available-actions.dto.ts';
import { GanttRoutePointAvailableActionsAdapter } from '@/modules/shared/adapters/gantt-route-point-available-actions.adapter.ts';
import type { GanttRoutePointAvailableActionsRequest } from '@/modules/shared/requests/gantt-route-point-available-actions.request.ts';

export default class GanttApi {
  static async getItems(docId: number): Promise<GanttItem[]> {
    const response = await Api.post(GanttEndPoint.GetItems, { doc_id: docId });
    return response.items.map((item: unknown) => new GanttItem(item));
  }

  static async getLinkOptions(documentId: number, signal?: AbortSignal) {
    const response = await Api.post(GanttEndPoint.GetList, { doc_id: documentId }, signal);
    const items = GanttItemAdapter.mapList(response.items);
    return GanttLinkOptionCreator.createList(items);
  }

  static async getAvailableActions(request: GanttRoutePointAvailableActionsRequest, signal?: AbortSignal) {
    const response: GanttRoutePointAvailableActionsDto = await Api.post(
      GanttEndPoint.GetAvailableActions,
      request,
      signal
    );

    return GanttRoutePointAvailableActionsAdapter.map(response, request.rp_id);
  }
}
